<template>
    <div>
        <div class="craft">
            <div class="part-one">
                <div class="base-title">
                    <div class="part-one-content">
                        <img class="part-one-title-img" src="../assets/imgs/craft/part-1-title.png" alt="" />
                        <div class="part-text part-one-text">
                            为鼓励企业引进和培育急需紧缺技能人才，按照“人才新政12条”“人才新政3.0版”，对企业新引进、符合条件的急需紧缺技能人才发放安家补贴。
                        </div>
                    </div>
                </div>
            </div>
            <div class="part-two">
                <img src="../assets/imgs/craft/part-2-title.png" class="part-two-title-img" />
                <div class="part-title part-two-title" style="margin-top: 1.44rem">
                    需同时满足以下条件：
                </div>
                <div class="part-two-content">
                    <div v-for="item in part2" :key="item.id" style="margin-bottom: 0.22rem; position: relative">
                        <div class="part-two-dot">{{ item.id }}</div>
                        {{ item.text }}
                    </div>
                </div>
            </div>
            <div class="part-three">
                <img src="../assets/imgs/craft/part-3-title.png" class="part-two-title-img" />
                <div class="part-three-items part-text" v-for="item in part3" :key="item.id" :style="item.boxHeight">
                    {{ item.text }}
                    <div v-if="item.id === 2">
                        注：《成都市人才开发指引(人才白皮书)》，拟于每年4月发布。
                    </div>
                    
                </div>
                <div class="part-text" style="color: #3d5aa3">
                        注：急需紧缺技能人才安家补贴与博士后人才生活资助、急需紧缺专业技术人才安家补贴、优秀海外高校毕业生创新创业补贴等政策均不能重复享受 
                    </div>
            </div>
            <div class="sxcl">
                <img class="top" src="./../assets/imgs/craft/jxjqjnrc_sqlc.png" alt="" />
                <div class="content">
                    <div class="title">
                        <span class="hollow-cricle"></span> 集中申报
                    </div>
                    <div class="describe mar-t3">
                        <div class="describe-item" style="font-weight: bold">
                            市人社局根据年度计划印发文件，高技能人才所在企业向注册地人社部门提出申请。提交以下材料：
                        </div>
                        <div style="display: flex" class="describe-item mar-t3">
                            <div class="num">1</div>
                            <div class="">
                                成都市引进急需紧缺高技能人才安家补贴申请表；
                            </div>
                        </div>
                        <div style="display: flex" class="describe-item mar-t3">
                            <div class="num">2</div>
                            <div class="">
                                企业营业执照、完税证明的原件及复印件；
                            </div>
                        </div>
                        <div style="display: flex" class="describe-item mar-t3">
                            <div class="num">3</div>
                            <div class="">
                                引进人才的身份证、职业资格证书、职业成就认定材料、劳动合同或工作协议的原件及复印件。
                            </div>
                        </div>
                    </div>
                    <div class="title">
                        <span class="hollow-cricle" style="margin-top: 0.24rem"></span>
                        区（市）县初审推荐
                    </div>
                    <div class="title">
                        <span class="hollow-cricle" style="margin-top: 0.24rem"></span>
                        市人社局复核
                    </div>
                    <div class="title">
                        <span class="hollow-cricle" style="margin-top: 0.24rem"></span>
                        公示确认
                    </div>
                </div>
            </div>
            <div class="contact">
                <img class="top" src="./../assets/imgs/label/contact4.png" alt="" />
                <div class="content">
                    <div class="number">
                        <span class="label">政策咨询电话：</span>
                        <div>
                            <a href="tel:028-61888231">028-61888231</a>
                        </div>
                    </div>
                    <div class="unit">
                        <span class="label">责任单位：</span>
                        成都市人力资源和社会保障局职业能力建设处
                    </div>
                </div>
            </div>
            <div class="part-five">
                <img src="../assets/imgs/15/code.png" style="
                                width: 1.94rem;
                                height: 1.94rem;
                                margin-right: 0.25rem;
                            " />
                <img src="../assets/imgs/15/code-text.png" style="width: 3.73rem; height: 1.83rem" alt="" />
            </div>
            <!-- <bottom phone="028-61888231" unit="成都市人力资源和社会保障局职业能力建设处"></bottom> -->
        </div>
        <call phone="028-61888231"></call>
    </div>
</template>

<script>
// import bottom from "../components/bottom.vue";
import call from "../components/call.vue";

export default {
    name: "craft",
    data() {
        return {
            part2: [
                {
                    id: 1,
                    text: "本市重点产业链“链主企业”及上下游重点产业企业新引进的急需紧缺技能人才；",
                },
                {
                    id: 2,
                    text: "掌握专门知识和技术，具备一定操作技能，在工作实践中能够运用自己技术和能力进行实际操作，取得初级工、中级工、高级工、技师和高级技师等国家职业资格证书或职业技能等级证书，以及其他具备相应职业技能水平的人员；",
                },
                {
                    id: 3,
                    text: "符合《成都市急需紧缺高端技能人才目录》Ⅰ、Ⅱ、Ⅲ、Ⅳ四类界定范围，或符合引进当年《成都市人才开发指引（人才白皮书）》中相关区域人才紧缺指数3星岗位要求的技能人才。",
                },
            ],
            part3: [
                {
                    id: 1,
                    boxHeight: "",
                    text: "（一）符合《成都市急需紧缺高技能人才目录》Ⅰ、Ⅱ、Ⅲ类条件之一的人才，从引进的次月起3年内，给予3000元/人·月的安家补贴。",
                },
                {
                    id: 2,
                    boxHeight: "",
                    text: "（二）符合《成都市急需紧缺高技能人才目录》Ⅳ类条件之一的人才或符合《成都市人才开发指引（成都人才白皮书）》中紧缺度3星岗位要求的人才，从引进的次月起3年内，给予2000元/人·月的安家补贴。",
                },
            ],
            part4: [
                {
                    id: 11,
                    title: "title-bg",
                    label: "集中申报",
                    content1: {
                        title: "",
                        text: "市人社局根据年度计划印发文件，高技能人才所在企业向注册地人社部门提出申请。提交以下材料：",
                    },
                    content2: [
                        "1．成都市引进急需紧缺高技能人才安家补贴申请表；",
                        "2．企业营业执照、完税证明的原件及复印件；",
                        "3．引进人才的身份证、职业资格证书、职业成就认定材料、劳动合同或工作协议的原件及复印件。",
                    ],
                    boxHeight: "",
                },
                {
                    id: 21,
                    label: "区（市）县初审推荐",
                    title: "title-bg title-bg2",
                    content1: {
                        title: "",
                        text: "",
                    },
                    content2: "",
                    boxHeight: "",
                },
                {
                    id: 31,
                    label: "市人社局复核",
                    title: "title-bg title-bg3",
                    content1: {
                        title: "",
                        text: "",
                    },
                    content2: "",
                    boxHeight: "",
                },
                {
                    id: 41,
                    label: "公示确认",
                    title: "title-bg title-bg4",
                    content1: {
                        title: "",
                        text: "",
                    },
                    content2: "",
                    boxHeight: "border:none",
                },
            ],
        };
    },
    components: {
        // bottom,
        call,
    },
    created() { },
    mounted() { },
    computed: {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.craft {
    background: #0839b7;
    overflow: hidden;
    padding: 0.24rem 0.12rem;
    padding-bottom: 1.65rem;
    box-sizing: border-box;
    width: 100vw;
    height: 100vh;
    overflow-y: auto;

    .part-title {
        font-size: 0.34rem;
        // //font-family:: PingFang SC-Bold, PingFang SC;
        font-weight: bold;
        color: #333333;
        position: relative;

        &::before {
            position: absolute;
            content: "";
            width: 0.28rem;
            height: 0.28rem;
            border-radius: 50%;
            background: none;
            border: 0.06rem solid #ff6d60;
            box-sizing: border-box;
            top: 0.08rem;
            left: -0.2rem;
        }
    }

    .part-text {
        font-size: 0.26rem;
        // //font-family:: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #4e4e4e;
        line-height: 0.44rem;
        text-align: left;
    }

    .part-one {
        width: 7.5rem;
        height: 6.6rem;
        margin: 0 auto;

        .base-title {
            width: 7.26rem;
            height: 5.6rem;
            background: url(../assets/imgs/15/base-title.png);
            background-size: 100% 100%;
            position: relative;

            .part-one-content {
                width: 6.85rem;
                background: #ffffff;
                border-radius: 10px;
                position: absolute;
                top: 4.02rem;
                left: 0.22rem;
                padding-bottom: 0.35rem;
                padding-left: 0.36rem;
                padding-right: 0.37rem;
                box-sizing: border-box;

                .part-one-title-img {
                    position: absolute;
                    top: -0.32rem;
                    left: 0;
                    width: 6.86rem;
                    height: 1.12rem;
                }

                .part-one-text {
                    margin-top: 0.9rem;
                }
            }
        }
    }

    .part-two-title-img {
        width: 7.03rem;
        height: 1.37rem;
        top: 0;
        left: -0.18rem;
        position: absolute;
    }

    .part-two {
        margin-left: 0.02rem;
        width: 6.85rem;
        margin-top: 0.22rem;
        background: #e8eeff;
        border-radius: 10px;
        padding-left: 0.33rem;
        padding-right: 0.3rem;
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 0.22rem;
        border: 0.00001px solid transparent;
        position: relative;

        .part-two-title {
            text-align: left;
            margin-left: 0.33rem;

            &::before {
                position: absolute;
                content: "";
                width: 0.28rem;
                height: 0.28rem;
                border-radius: 50%;
                background: none;
                border: 0.06rem solid #ff6d60;
                box-sizing: border-box;
                top: 0.08rem;
                left: -0.35rem;
            }
        }

        .part-two-content {
            margin-top: 0.2rem;
            margin-bottom: 0.3rem;
            width: 6.22rem;
            background: #ffffff;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 0.34rem 0.24rem 0.25rem 0.67rem;
            font-size: 0.26rem;
            // //font-family:: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #4e4e4e;
            line-height: 0.44rem;
            text-align: left;

            .part-two-dot {
                position: absolute;
                top: 0;
                left: -0.46rem;
                width: 0.36rem;
                height: 0.36rem;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                color: #fff;
                font-size: 0.26rem;
                background: #739bfe;
                border-radius: 50%;
            }
        }
    }

    .part-three {
        width: 6.85rem;
        background: #e8eeff;
        border-radius: 10px;
        margin-left: 0.02rem;
        margin-top: 0.22rem;
        box-sizing: border-box;
        display: inline-block;
        position: relative;
        padding: 1.54rem 0.25rem 0.35rem 0.25rem;

        .part-three-items {
            width: 6.35rem;
            background: #ffffff;
            border-radius: 10px;
            padding: 0.31rem;
            box-sizing: border-box;
            position: relative;
            margin-bottom: 0.22rem;
        }
    }

    .part-four {
        width: 6.85rem;
        background: #e8eeff;
        border-radius: 10px;
        margin-left: 0.02rem;
        margin-top: 0.22rem;
        box-sizing: border-box;
        display: inline-block;
        position: relative;
        padding: 1.2rem 0.25rem 0 0.25rem;

        .main-content {
            margin-top: 0.34rem;
            width: 6.35rem;
            background: -webkit-linear-gradient(top, #fff, #e8eeff);
            border-radius: 10px;
            box-sizing: border-box;
            padding-top: 0.8rem;
            padding-left: 0.35rem;
            padding-right: 0.31rem;

            .part-four-items {
                box-sizing: border-box;
                border-left: 0.02rem dashed #739bfe;
                margin-bottom: 0.6rem;
                padding-left: 0.33rem;
                padding-top: 0.2rem;
                position: relative;
                font-size: 0.26rem;
                // //font-family:: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #4e4e4e;
                line-height: 0.44rem;
                text-align: left;

                .title-bg {
                    position: absolute;
                    width: 3.31rem;
                    height: 0.6rem;
                    top: -0.6rem;
                    left: -0.25rem;
                    display: inline-flex;
                    align-items: center;
                    font-size: 0.34rem;
                    // //font-family:: PingFang SC-Bold, PingFang SC;
                    font-weight: bold;
                    color: #3d5aa3;
                    padding-left: 0.58rem;
                    background: url(../assets/imgs/craft/part4-1.png);
                    background-size: 100% 100%;
                }

                .title-bg2 {
                    background: url(../assets/imgs/craft/part4-2.png);
                    background-size: 100% 100%;
                }

                .title-bg3 {
                    background: url(../assets/imgs/craft/part4-3.png);
                    background-size: 100% 100%;
                }

                .title-bg4 {
                    background: url(../assets/imgs/craft/part4-4.png);
                    background-size: 100% 100%;
                }

                .inside-title {
                    font-weight: 800;
                }

                .part-four-content2 {
                    font-weight: bolder;
                }
            }
        }
    }

    .part-five {
        width: 6.85rem;
        background: #fff;
        border-radius: 10px;
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 0.22rem;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0.35rem;
    }

    .bottom-info {
        margin-top: 0.22rem;
        font-size: 0.24rem;
        // //font-family:: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #97a9d9;

        a {
            text-decoration: none;
            // color: #97a9d9;
        }
    }
}

.sxcl {
    position: relative;
    margin-top: 0.22rem;

    .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
    }

    .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.45rem auto 0;
        padding: 0 0.33rem 0.64rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        line-height: 0.44rem;

        .title {
            font-size: 0.36rem;
            font-weight: bold;
            color: #333333;
            text-align: left;
            line-height: 0.5rem;
        }

        .describe {
            background: #fff;
            border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
            opacity: 1;
            padding: 0.33rem 0.33rem 0.3rem 0.3rem;

            .num {
                min-width: 0.39rem;
                height: 0.39rem;
                background: #739bfe;
                color: #ffffff;
                display: inline-flex;
                border-radius: 50%;
                justify-content: center;
                align-items: center;
                margin-right: 0.14rem;
            }
        }
    }
}
</style>
